import AddNewInsurance from "./AddNewInsurance"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import { useState, useReducer } from "react"
import { enumUtil } from "../../../../utils/Enum"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { useEffect } from "react"
import Loader from "../../../shared/Loader/Loader"
import SearchHeader from "../../Shared/SearchHeader"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import handleCopyText from "../../../shared/CopyData"
import isNull from "../../../../utils/NullChecking"
import { Settings } from "@mui/icons-material"
import { connect } from "react-redux"
import Payerpopup from "./Payerpopup"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import usePagination from "../../../../customhooks/usePagination"
const Insurance = (props) => {
    const API_URL = enumUtil.controller.General
    const { type, Settings } = { ...props }
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    const [InsuranceID, setInsuranceID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnrollmentStatus, setEnrollmentStatus] = useState('');

    const [IsOpenInsurance, setIsOpenInsurance] = useState(false);
    const [InsuranceData, setInsuranceData] = useState([]);
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState();
    const [show, setShow] = useState(false);
    const [totalCounts, setTotalCounts] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false   // set true if want to display cards as well
    }

    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////

    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    const [searchParamType, setSearchparamType] = useState("");
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    // const handleSelectData = (data) => {
    //     setPerPage(data.value)
    //     setPageNo(1)
    // }
    ///////////
    const LoadData = (param, types) => {
        setIsLoading(true)
        // setInsuranceData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Insurance,
            "SearchParam": param,
            'SEARCHCRITERIA': {
                'EnrollmentStatus': EnrollmentStatus
            },
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            handleGridHeader({ defaultData: response.Rows })
            setInsuranceData(response.Rows)
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setIsOpenInsurance(true)
                }
            }
        }).catch((error) => {
            setTotalCounts(0)
            setInsuranceData([])
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (InsuranceData?.length == 0 && isNull(searchParamType)) {
                    setIsOpenInsurance(true)
                }
            }
        })
    }
    // const [searchEnter, setSearchEnter] = useState(false);

    const handleClearSearch = () => {
        setSearchParam('')
        // setSearchEnter(false);
    }
    const SearchByParam = () => {

        if (!isNull(searchParam)) {
            // setPageNo('1')
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
            // setSearchEnter(true);
        }
    }
    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo, isClose])

    const AddInsurance = (ID) => {
        setIsOpenInsurance(true)
        setInsuranceID(ID)
    }
    const CloseInsurance = () => {
        setIsOpenInsurance(false)
    }
    const DeleteInsurance = () => {
        setIsOpenInsurance(false)
        setIsClose((Math.random()));
    }
    let PopupScreen = "";
    if (IsOpenInsurance) {
        PopupScreen = <AddNewInsurance IsOpenInsurance={IsOpenInsurance} onClose={CloseInsurance} onDeleteInsurance={DeleteInsurance} InsuranceID={InsuranceID} type={type} />
    }
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }
    const columns = [


        {
            key: 'Name',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Insurance Name'} sortIcon={true} type={'string'} colKey={'Name'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <button className="btn btn-link w-100 p-0" >
                            <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                                <div className="copy_icon validation_message" onClick={() => AddInsurance(row.InsuranceID)}>
                                    {row.Name}
                                </div>
                                <div className="icon_copy">
                                    <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.InsuranceID, row.Name)}></i>
                                    <p class="tool_tip xsm_text text-light">Copy</p>
                                </div>
                                {copiedText[`${row.InsuranceID}-${row.Name}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                            </div>
                        </button>
                    </>
                );
            }
        },
        {
            key: 'ShortName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Short Name'} sortIcon={true} type={'string'} colKey={'ShortName'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    // <button className="btn btn-link w-100 p-0" >
                    <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                        <div className="validation_message" >{row.ShortName} </div>
                        <div className="icon_copy">
                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.InsuranceID, row.ShortName)}></i>
                            <p class="tool_tip xsm_text text-light">Copy</p>
                        </div>
                        {copiedText[`${row.InsuranceID}-${row.ShortName}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                    </div>
                    // {/* </button> */}
                );
            },
        },
        {
            key: 'InsuranceType',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Type'} sortIcon={true} type={'number'} colKey={'InsuranceType'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
        },
        {
            key: 'PayerID',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Payer ID'} sortIcon={true} type={'number'} colKey={'PayerID'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
        },
        {
            key: 'ClaimReceiver',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Claim Receiver'} sortIcon={true} type={'string'} colKey={'ClaimReceiver'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
        },
        {
            key: 'PrimaryBillingMethod',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'PRI Billing'} sortIcon={true} type={'string'} colKey={'PrimaryBillingMethod'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
        },
        {
            key: 'ClaimEnrollmentRequired',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'CLM Enrollment'} sortIcon={true} type={'string'} colKey={'ClaimEnrollmentRequired'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
            renderCell({ row }) {

                return (
                    <>
                        <div className="d-flex align-items-center">
                            <p>{row.ClaimEnrollmentRequired === "True" ? "Yes" : "No"} </p>
                            {row?.ClaimEnrollmentStatus === "In Process" || row?.ClaimEnrollmentStatus === "InProcess" ? <p className="text fst-italic font-m validate-color"> - In Process</p> : row?.ClaimEnrollmentStatus === "Not Started" || row?.ClaimEnrollmentStatus === "NotStarted" ? <p className="text fst-italic font-m Hold-clr"> - Not Started</p> : row?.ClaimEnrollmentStatus === "Completed" ? <p className="text fst-italic font-m za-harlequen-green-clr"> - Complete</p> : row?.ClaimEnrollmentStatus}

                            {/* <p className="text fst-italic font-m validate-color">In Process</p> */}
                            {/* For Not Started add this class Hold-clr */}
                            {/* For Not Completed add this class za-harlequen-green-clr */}
                        </div>
                    </>
                );
            },
        },
        {
            key: 'ERAEnrollmentRequired',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'ERA Enrollment'} sortIcon={true} type={'string'} colKey={'ERAEnrollmentRequired'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
            renderCell({ row }) {

                return (
                    <>
                        <div className="d-flex align-items-center">

                            <p> {row.ERAEnrollmentRequired === "True" ? "Yes" : "No"}  </p>
                            {row?.ERAEnrollmentStatus === "In Process" || row?.ClaimEnrollmentStatus === "InProcess" ? <p className="text fst-italic font-m validate-color"> - In Process</p> : row?.ERAEnrollmentStatus === "Not Started" || row?.ClaimEnrollmentStatus === "NotStarted" ? <p className="text fst-italic font-m Hold-clr"> - Not Started</p> : row?.ERAEnrollmentStatus === "Completed" ? <p className="text fst-italic font-m za-harlequen-green-clr"> - Complete</p> : row?.ERAEnrollmentStatus}
                            {/* <p className="text fst-italic font-m validate-color">In Process</p> */}
                            {/* For Not Started add this class Hold-clr */}
                            {/* For Not Completed add this class za-harlequen-green-clr */}
                        </div>
                    </>
                );
            },
        },
        {
            key: 'ActiveDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Active Date'} sortIcon={true} type={'string'} colKey={'ActiveDate'} data={InsuranceData} setData={setInsuranceData} />),
            resizable: true,
        },
    ]
    const [isOpenpayer, setIsOpenPayer] = useState(false)

    const handleOpenPayer = () => {
        setIsOpenPayer(true)
    }

    const handleClosePayer = () => {
        setIsOpenPayer(false)
        // setIsClose((Math.random()));

    }
    const closeLoaddata = () => {
        setIsOpenPayer(false)
        setIsClose((Math.random()));
    }

    let payerPopup = ""

    if (isOpenpayer) {
        payerPopup = <Payerpopup isOpenPayer={isOpenpayer} Close={handleClosePayer} CloseLoad={closeLoaddata} />
    }

    const CardView = () => setShow(true);
    const TableView = () => setShow(false);
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }

    const [is, setIs] = useState(false);
    const handleChangeStatus = (e) => {
        setIs(false)
        setEnrollmentStatus(e.target.value)
    }
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true)
        if (type === 'client' && !isNull(selectedData)) {
            setEnrollmentStatus(selectedData.value)
        } else if (type === 'server' && !isNull(selectedData)) {
        } else {
            setEnrollmentStatus('')
        }
        return selectedData
    }
    const clearFilter = () => {
        setSearchParam('')
        setEnrollmentStatus('')
    }
    const InsuranceBody = () => {
        return (
            <>
                {payerPopup}
                <div className={show ? 'container-fluid  row row-half  br-clr align-items-end py-1 pe-0' : 'container-fluid  row row-half  br-clr align-items-end py-1 pe-0'}>
                    <div className="position-relative">
                        <div className="row row-half align-items-end">
                            <div className="col-md-4 form-rounded">
                                <div className="input">
                                    <div className='input-group hk-input-search'>
                                        <input type="text" className='form-control fc-xs'
                                            placeholder='Search by name or id…'
                                            onChange={e => setSearchParam(e.target.value)}
                                            onKeyDown={SearchOnEnter}
                                            value={searchParam}
                                        />

                                        {searchParam?.length > 0 ?
                                            <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                                <i className="bi bi-x"></i>
                                            </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                                <i className="bi bi-search"></i>
                                            </span>}

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 multipleSearch-rounded">
                                <div className='input'>
                                    <SuperSearchList
                                        type="client"
                                        id='EnrollmentStatus'
                                        name='EnrollmentStatus'
                                        searchValue={EnrollmentStatus}
                                        data={[
                                            { value: 'In Process', display: 'In Process' },
                                            { value: 'Not Started', display: 'Not Started' },
                                            { value: 'Completed', display: 'Completed' },
                                        ]}
                                        onChange={handleChangeStatus}
                                        getSelectedData={handleSelectedData}
                                        is={is}
                                        icon={'Simple'}
                                        sup_btn='sup_btn'
                                        sup_inp='superSearchVisitInp'
                                        className="form-control rounded"
                                        placeholder='Search Status...'
                                    />
                                </div>
                            </div>
                            <div className="col-md-5 d-flex align-items-end justify-content-between gap-10">
                                <div className='btns-group-flex claims_btns flex-nowrap'>
                                    <button className='btn btn-orange btn-xs no-width rounded' onClick={SearchByParam}>Search</button>
                                    <button className='btn btn-outline btn-xs no-width rounded me-1' onClick={clearFilter}>Clear</button>
                                    <button className=' btn btn-validate btn-xs no-width rounded w-auto ar-payer-button position-static' onClick={() => handleOpenPayer()}>Payer List</button>
                                </div>
                                <div className="w-100 ps-0">
                                    <SearchHeader
                                        AddNew={AddInsurance}
                                        Excel={handleExcel}
                                        PDF={handlePdf}
                                        Delete={handleDelete}
                                        Filter={handleFilter}
                                        cardView={CardView}
                                        tableView={TableView}
                                        show={show}
                                        searchButton={searchButton}
                                        Key={621}
                                        Name={'Insurance'}
                                        Counts={totalCounts}
                                    />

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                {show === false ?
                    <Table
                        columns={columns}
                        rows={InsuranceData}
                        height='500px'
                        rowClass={rowClass}
                        // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                        dynamicClass='fill-grid DataGrid-Table hk-exp-table insurance_table'
                        rowHeight={25}
                        PerPage={PerPage}
                        PageNo={PageNo}
                        TotalPages={TotalPages}
                        handlePageClick={handlePageClick}
                        PreviousPage={PreviousPage}
                        handleFingByCreteria={handleFingByCreteria}
                        NextPage={NextPage}
                        Key={621}
                        Name={'Insurance'}
                        isLoading={isLoading}
                        TableName={'Insurance'}
                        handleSelectData={handleSelectData}
                        LoadData={() => LoadData(searchParam)}
                        ClearSearch={clearFilter}
                    /> : null
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(InsuranceData?.length == 0 && isNull(searchParamType)){
    //             setIsOpenInsurance(true)
    //         }
    //     }
    // },[InsuranceData, searchParamType])
    return (
        <>
            {/* {PopupScreen} */}
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    {/* {InsuranceData?.length > 0 || !isNull(searchParamType) ? */}
                    <>
                        {IsOpenInsurance ? <>{PopupScreen}</> : <>{InsuranceBody()}</>}
                    </>
                    {/* : <>{PopupScreen}</> */}
                    {/* } */}
                </> :
                <>
                    {PopupScreen}
                    {InsuranceBody()}
                </>
            }

        </>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer
    }
}
export default connect(mapStateToProps)(Insurance)